import { useEffect, useState } from "react";
import type { TEventMessages } from "../../../../../../services/api/instances/researchApi/types";
import { generateId } from "../../../../../../shared/utils/generateId";
import { TObjectWithId } from "../../types";
import { EventCard } from "../EventCard";
import styles from "./styles.module.css";

interface Props {
  messages: TEventMessages[];
}

export const EventMessage = ({ messages }: Props) => {
  return (
    <div className={styles["messages-container"]}>
      {messages.map((item) => (
        <EventCard
          key={item.timestamp}
          eventType={"message"}
          eventBody={<div className={styles["message"]}>{item.message}</div>}
          className={styles["event-message-card"]}
        />
      ))}
    </div>
  );
};
